import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";

const getEnv = (key: string) => {
  return process.env[`REACT_APP_${key}`] || process.env[`VITE_PUBLIC_${key}`] || process.env[`PUBLIC_${key}`] || "";
};

const firebaseConfig = {
  apiKey: getEnv("FIREBASE_API_KEY"),
  authDomain: getEnv("FIREBASE_AUTH_DOMAIN"),
  projectId: getEnv("FIREBASE_PROJECT_ID"),
  storageBucket: getEnv("FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: getEnv("FIREBASE_MESSAGING_SENDER_ID"),
  appId: getEnv("FIREBASE_APP_ID"),
};

// Initialize Firebase only once
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

export const auth = getAuth(app);
